import React, { FC } from 'react';
import { View } from 'react-native';
import { TimeLineWrapperProps } from '@v2/pages/batch/details/modules/batch/interfaces';
import { styles } from '@v2/pages/batch/details/modules/batch/components/BatchDetailsBlock/styles';

export const TimeLineWrapper: FC<TimeLineWrapperProps> = ({ rowStyles, leftColumnStyles, rightColumnStyles, children, leftContent }) => {
  return (
    <View
      style={[
        rowStyles ?? { ...styles.rowStylesWithoutPaddings, ...styles.rowPaddings },
        { paddingTop: 0, paddingBottom: 0, alignItems: 'baseline' },
      ]}
    >
      <View style={leftColumnStyles ?? styles.leftColumnStyles}>{leftContent}</View>
      <View style={rightColumnStyles ?? styles.rightColumnStyles}>{children}</View>
    </View>
  );
};
